import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppRoot from './client/app-root/app';
import * as serviceWorker from './serviceWorker';
import { ErrorBoundary } from './client/app-root/error-boundary';
import AnalyticsTrackerInstance from './analytics';
import AppGuide from './app-guide';

AnalyticsTrackerInstance.initAnalytics();
const AppGuidInstance = new AppGuide();
AppGuidInstance.loadAppGuideScript();

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AppRoot />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
